export default __webpack_public_path__ + "static/media/up_arrow.bb07cfbe.svg";